import { GridItem } from '..';
import React from 'react';
import RichText from '../../RichText';
import { mergeClassNames } from '../../../../utils';
import styles from './index.module.scss';

export default function GridItemHero({ heading, description, className = '' }) {
  return (
    <GridItem key="hero" className={mergeClassNames(styles.gridItemHero, className)}>
      <div className={styles.inner}>
        <h4 className={styles.heading}>{heading}</h4>
        <RichText className={styles.description}>{description}</RichText>
      </div>
    </GridItem>
  );
}
